import { render, staticRenderFns } from "./DeliveryReport.vue?vue&type=template&id=0737d2ba&scoped=true&lang=pug"
import script from "./DeliveryReport.vue?vue&type=script&lang=js"
export * from "./DeliveryReport.vue?vue&type=script&lang=js"
import style0 from "./DeliveryReport.vue?vue&type=style&index=0&id=0737d2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0737d2ba",
  null
  
)

export default component.exports